module.exports = __webpack_public_path__ + "assets/img/icon-06.2b0b9acb.png";